'use client';
import SXMLink from '@/shared-components/SXMLink';
import { useEffect, useState } from 'react';
import Button, { ButtonProps } from 'de-sxm-reactlib-2/components/atoms/Button/Button';
import styles from './chatlink.module.scss';

interface Props {
    type: LinkType | undefined;
    variant?: ButtonProps['variant'];
    colorSet?: ButtonProps['colorSet'];
    bgColor?: string;
    text: string | undefined;
    iconUrl?: string;
    iconWidth?: number;
    iconHeight?: number;
}

export default function ChatLink({
    type,
    variant = 'primary',
    colorSet,
    bgColor,
    text,
    iconUrl,
    iconHeight,
    iconWidth,
}: Props): React.JSX.Element {
    const [component, setComponent] = useState(<></>);

    useEffect(() => {
        const clientWindow = window as BrowserWindow;

        function openChat(e: React.MouseEvent) {
            e.preventDefault();
            if (clientWindow && clientWindow.sierraSXM) {
                clientWindow.sierraSXM.openChatModal();
            }
        }

        if (type) {
            if (type.indexOf('CTA') >= 0) {
                setComponent(
                    <div className={styles.chatSpacing}>
                        <Button type="button" variant={variant} colorSet={colorSet} onClick={openChat} fitting='hug-contents'>
                            {text}
                        </Button>
                    </div>,
                );
            } else if (type === 'Text') {
                setComponent(
                    <SXMLink href="" onClick={openChat}>
                        {text}
                    </SXMLink>,
                );
            } else if (type === 'LinkInfoCard') {
                // To be added if still being used
            }
        }
    }, [bgColor, iconUrl, iconHeight, iconWidth, text, variant, type, colorSet]);

    return component;
}
